<template>
  <div>
    <!-- Table -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="this.$store.state.configuration.configurations.data"
        hide-default-footer
        :loading="this.$store.state.configuration.isLoading"
        :items-per-page="20"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.status`]="item">
          <v-chip
            :color="getConfigurationStatuColor(item.item.status)"
            dark
            small
          >
            {{ getConfigurationStatus(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="show(item.item.id)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="edit(item.item.id)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <!-- Dialog Show - Edit -->
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <v-card-title> {{ titleDialog }} Configuración </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formConfiguration" v-model="formConfiguration">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.validity"
                    :rules="[this.$store.state.rules.required]"
                    label="Vigencia"
                    :readonly="!editConfiguration"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.validitySince"
                        label="Vigencia Desde"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                        :readonly="!editConfiguration"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.validitySince"
                      @input="menuStartDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="model.validityUntil"
                        label="Vigencia Hasta"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                        :readonly="!editConfiguration"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.validityUntil"
                      @input="menuEndDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.contract_reference"
                    :rules="[this.$store.state.rules.required]"
                    label="Contrato"
                    :readonly="!editConfiguration"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.contract_consecutive"
                    :rules="[this.$store.state.rules.required]"
                    label="Cons. Contratos"
                    :readonly="!editConfiguration"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="model.bill_consecutive"
                    :rules="[this.$store.state.rules.required]"
                    label="Cons. Cuentas"
                    :readonly="!editConfiguration"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="model.status"
                    :items="status"
                    :rules="[this.$store.state.rules.required]"
                    label="Estado"
                    :readonly="!editConfiguration"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="close">Cerrar</v-btn>
          <v-btn
            text
            color="success"
            @click="updateConfiguration"
            v-if="editConfiguration && currentConfiguration"
            >Actualizar</v-btn
          >
          <v-btn
            text
            color="success"
            @click="storeConfiguration"
            v-if="editConfiguration && !currentConfiguration"
            >Crear</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Button active dialog / create record-->
    <v-btn
      class="mx-2"
      fab
      dark
      bottom
      absolute
      right
      color="secondary"
      @click="create"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_ALERT } from "@/store/alert";
import { SET_CONFIGURATIONS } from "@/store/configuration";
export default {
  name: "Configuration",
  data: () => ({
    dialog: false,
    titleDialog: "",
    menuEndDate: null,
    menuStartDate: null,
    editConfiguration: false,
    formConfiguration: true,
    currentConfiguration: null,
    model: {
      bill_consecutive: "",
      contract_reference: "",
      contract_consecutive: "",
      validitySince: "",
      validityUntil: "",
      validity: "",
      status: "",
    },
    headers: [
      {
        text: "Vigencia",
        filterable: false,
        value: "validity",
      },
      {
        text: "Contrato",
        filterable: false,
        value: "contract_reference",
      },
      {
        text: "Cons. Contratos",
        filterable: false,
        value: "contract_consecutive",
      },
      {
        text: "Cons. Cuentas",
        filterable: false,
        value: "bill_consecutive",
      },
      {
        text: "Estado",
        filterable: false,
        value: "status",
      },
      {
        text: "Acciones",
        filterable: false,
        value: "actions",
      },
    ],
    status: [
      { value: "ACTIVE", text: "ACTIVO" },
      { value: "INACTIVE", text: "INACTIVO" },
    ],
    pagination: {
      current: 0,
      total: 0,
    },
  }),
  created() {
    this.$store.dispatch("getConfigurations");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_CONFIGURATIONS) {
        this.pagination.current =
          state.configuration.configurations.current_page;
        this.pagination.total = state.configuration.configurations.last_page;
      }
    });
  },
  computed: {
    ...mapGetters(["getConfigurationStatus", "getConfigurationStatuColor"]),
  },
  methods: {
    async updateConfiguration() {
      if (!this.$refs.formConfiguration.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("updateConfiguration", {
        id: this.currentConfiguration.id,
        form: this.model,
      });
      this.close();
    },
    async storeConfiguration() {
      if (!this.$refs.formConfiguration.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.$store.dispatch("createConfiguration", this.model);
      this.close();
    },
    create() {
      this.editConfiguration = true;
      this.titleDialog = "Crear";
      this.dialog = true;
    },
    show(id) {
      this.setData(id);
      this.editConfiguration = false;
      this.titleDialog = "Ver";
      this.dialog = true;
    },
    edit(id) {
      this.setData(id);
      this.editConfiguration = true;
      this.titleDialog = "Editar";
      this.dialog = true;
    },
    setData(id) {
      const configurations =
        this.$store.state.configuration.configurations.data;

      this.currentConfiguration = configurations.find((obj) => obj.id == id);

      this.model = {
        bill_consecutive: this.currentConfiguration.bill_consecutive,
        contract_reference: this.currentConfiguration.contract_reference,
        contract_consecutive: this.currentConfiguration.contract_consecutive,
        validitySince: this.currentConfiguration.validitySince,
        validityUntil: this.currentConfiguration.validityUntil,
        validity: this.currentConfiguration.validity,
        status: this.currentConfiguration.status,
      };
    },
    close() {
      this.currentConfiguration = null;
      this.model = {
        bill_consecutive: "",
        contract_reference: "",
        contract_consecutive: "",
        validitySince: "",
        validityUntil: "",
        validity: "",
        status: "",
      };
      this.dialog = false;      
      this.$nextTick(() => {
        this.$refs.formConfiguration.resetValidation();
      });
    },
    nextPage() {
      this.$store.dispatch("nextPageCharges", this.pagination.current);
    },
  },
};
</script>

<style>
</style>